/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-unused-expressions */
import { getUserList, inviteEmail, postAcceptedInviteMember, changeEmail, verifyChangeEmail, deleteAccount } from 'APIs/account.api'
import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { call, put, takeLatest, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { REQUEST, SUCCESS } from 'Stores'
import { setLocalStorage, STORAGE } from 'Utils'
import { formatMessage } from 'Utils/formatMessage'
import { ACCOUNT_LIST, INVITE_EMAIL, POST_ACCEPT_INVITE_MEMBER, CHANGE_EMAIL, VERIFY_CHANGE_EMAIL, DELETE_ACCOUNT } from './constants'
import { makeSelectAccount } from './selectors'

export function* getAccountSaga({ payload }) {
  try {
    yield put(showOverlay())
    const data = yield call(getUserList, payload)
    yield put({
      type: SUCCESS(ACCOUNT_LIST),
      payload: {
        accountList: {
          count: data.result?.count,
          rows: data.result?.rows,
          delete: false
        }
      }
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: formatMessage(error) }))
  }
}

export function* inviteEmailSaga({ payload }) {
  try {
    yield put(showOverlay())
    yield call(inviteEmail, payload)
    yield put(hideOverlay())
    yield put(showModalMessage({ message: formatMessage('INVITE_SUCCESS'), type: 'success' }))
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: formatMessage(error) }))
  }
}

export function* postAcceptedInviteMemberSaga({ payload }) {
  try {
    yield put(showOverlay())
    yield call(postAcceptedInviteMember, payload)
    yield put(hideOverlay())
    yield put(push('/admin/accept-invitation/success'))
    yield put(showModalMessage({ message: 'Register success', type: 'success' }))
  } catch (error) {
    yield put(hideOverlay())
    if (error === 'INVITE_NOT_FOUND' || error === 'Invite not found') {
      yield put(push('/not-found'))
    }
    yield put(showModalMessage({ message: formatMessage(error) }))
  }
}

export function* changeEmailSaga({ payload }) {
  try {
    yield put(showOverlay())
    const { success } = yield call(changeEmail, payload)
    if (success) {
      yield put(showModalMessage({ message: formatMessage('VERIFY_EMAIL'), type: 'success' }))
    }
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: formatMessage(error) }))
  }
}

export function* verifyChangeEmailSaga({ payload }) {
  try {
    yield put(showOverlay())
    const { success, result } = yield call(verifyChangeEmail, payload)
    if (success) {
      setLocalStorage(STORAGE.EMAIL_CHANGE_VERIFY, result.email)
    }
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    if (error === 'TOKEN_EXPIRE_OR_INVALID') {
      yield put(showModalMessage({ message: formatMessage('CHANGE_EMAIL_INVALID') }))
    } else {
      yield put(showModalMessage({ message: formatMessage(error) }))
    }
    yield put(push('/not-found'))
  }
}

export function* deleteAccountSaga({ payload }) {
  try {
    yield put(showOverlay())
    const { success } = yield call(deleteAccount, payload)
    if (success) {
      const { accountList } = yield select(makeSelectAccount())
      yield put({
        type: SUCCESS(ACCOUNT_LIST),
        payload: {
          accountList: {
            count: accountList?.count,
            rows: accountList?.rows,
            delete: true
          }
        }
      })
      yield put(showModalMessage({ message: formatMessage('DELETE_ACCOUNT_SUCCESS'), type: 'success' }))
    }
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: formatMessage(error) }))
  }
}

export default function* paymentSaga() {
  yield takeLatest(REQUEST(ACCOUNT_LIST), getAccountSaga)
  yield takeLatest(REQUEST(INVITE_EMAIL), inviteEmailSaga)
  yield takeLatest(REQUEST(POST_ACCEPT_INVITE_MEMBER), postAcceptedInviteMemberSaga)
  yield takeLatest(REQUEST(CHANGE_EMAIL), changeEmailSaga)
  yield takeLatest(REQUEST(VERIFY_CHANGE_EMAIL), verifyChangeEmailSaga)
  yield takeLatest(REQUEST(DELETE_ACCOUNT), deleteAccountSaga)
}
